import React from 'react';
import styled from 'styled-components';

import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import PlaceIcon from '@mui/icons-material/Place';

import { formatDate } from 'ff/debrief/utils';

interface Props {
    origin?: string;
    dest?: string;
    start?: number;
    end?: number;
}

const TerminalDetails: React.FC<Props> = props => {
    const fmtStart = formatDate(props.start);
    const fmtEnd = formatDate(props.end);
    return (
        <TerminalsContainer style={{ minHeight: '120px' }}>
            <Stack direction="row" alignItems="center" spacing={2}>
                <PlaceIcon sx={{ color: '#697D90' }} />
                <Stack>
                    <Typography fontSize="16px" fontWeight="700">
                        {props.origin || <Skeleton width="50px" />}
                    </Typography>
                    <Typography fontSize="12px">
                        {fmtStart || <Skeleton width="121px" />}
                    </Typography>
                </Stack>
            </Stack>
            <DashedLine></DashedLine>
            <Stack direction="row" alignItems="center" spacing={2}>
                <PlaceIcon sx={{ color: '#697D90' }} />
                <Stack>
                    <Typography fontSize="16px" fontWeight="700">
                        {props.dest || <Skeleton width="50px" />}
                    </Typography>
                    <Typography fontSize="12px">
                        {fmtEnd || <Skeleton width="121px" />}
                    </Typography>
                </Stack>
            </Stack>
        </TerminalsContainer>
    );
};

const TerminalsContainer = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    &::after {
        content: '';
        border-right: 1px solid rgba(0, 0, 0, 0.05);
        display: flex;
        width: 1px;
        position: absolute;
        right: 0;
        top: -12px;
        bottom: -12px;
    }
`;

const DashedLine = styled.div`
    flex-grow: 1;
    border-left: 2px dashed #dfe3e6;
    margin: -10px 10px;
`;

export default TerminalDetails;
